import React from 'react';

import { MatchupHeader } from '@/components/bet-list/MatchupHeader';
import { TeamLogos } from '@/components/scoreboard/types';
import { formatEventHeaderString, useFormatEventHeader } from '@/feature/betslip-sbk/hooks/use-format-event-header';
import { getTeamColors } from '@/feature/event-details-sbk/utils/get-team-colors';

import { FeaturedEvent } from '../types';

type EventHeaderProps = {
    event: FeaturedEvent;
};

export const Header = ({ event }: EventHeaderProps) => {
    const { home, away } = getTeamColors(event);

    const teamLogos: TeamLogos = [
        {
            icon: event.away_team.logo_url ?? '',
            color: away.primary,
        },
        {
            icon: event.home_team.logo_url ?? '',
            color: home.primary,
        },
    ];

    const teamFallbackTextColors = [away.secondary, home.secondary];
    const shouldShowFallbackLogos: [boolean, boolean] = [away.shouldShowFallbackLogo, home.shouldShowFallbackLogo];

    const teamShortCodes = [event.away_team.short_code, event.home_team.short_code];

    const headerData = useFormatEventHeader(event);
    const eventHeader = formatEventHeaderString(headerData);

    const matchUpHeaderProps = {
        logos: teamLogos,
        teamFallbackTextColors,
        teamShortCodes,
        shouldShowFallbackLogos,
        isHeaderDisabled: false,
        eventHeader,
        isLive: headerData?.isLive ?? false,
    };
    return <MatchupHeader {...matchUpHeaderProps} />;
};
